<div class="full-dialog">

  <app-pop-up-header [title]="'ANAMNESE - INCLUSÃO DE ALERGIA'" (closeIcon)="close()"></app-pop-up-header>

  <div class="popup-body-allergies scrollbar" id="style-1">

    <div style="display: flex; justify-content: space-between;">

      <div style="display: flex; flex-direction: column;">

        <app-title [title]="'CATEGORIA'" [isMandatory]="isFirstQuestionnaire"
          [isConditionFilled]="checkIfCategorySelected()"></app-title>

        <app-input-text [width]="'370px'" [height]="'25px'" [searchField]="true" (getCaractersInput)="filterItem($event, 'category')"></app-input-text>

        <cmp-table-with-checkbox
          [arrayItems]="this.filteredCategory"
          [width]="'370px'"
          [height]="'470px'"
          (itemChecked)="clickCategory($event, true)"
          (itemSelectedBold)="clickCategory($event, false)"
        ></cmp-table-with-checkbox>

      </div>

      <div style="display: flex; flex-direction: column;">

        <app-title [title]="'TIPO'" [isMandatory]="isFirstQuestionnaire"
          [isConditionFilled]="checkIfTypeSelected()"></app-title>

        <app-input-text [width]="'370px'" [height]="'25px'" [searchField]="true" (getCaractersInput)="filterItem($event, 'type')"></app-input-text>

        <cmp-table-with-checkbox
          [arrayItems]="this.filteredType"
          [width]="'370px'"
          [height]="'470px'"
          (itemChecked)="clickType($event)"
          (newOthers)="addOthers($event)">
        </cmp-table-with-checkbox>

      </div>

      <div class="display-selected-items">

        <app-title [title]="'ALERGIAS DECLARADAS'" style="margin-top: 42px;"></app-title>

        <div *ngFor="let allergy of filterAllergiesSelected(allergies)" style="margin: 5px 10px;">

          <span style="font-weight: bold;"> {{ showTitle(allergy) }} </span>

          <mat-chip-set>
            <div *ngFor="let type of filterTypesSelected(allergy.items)">
              <mat-chip *ngIf="type.item !== ''">
                <div style="display: flex; align-items: center;">
                  <span style="margin-right: 10px"> {{ type.item }} </span>

                  <button class="add-edit-button">
                    <img src="assets/icons/chip_close.svg" (click)="deleteTypeSelected(type, allergy)">
                  </button>
                </div>

              </mat-chip>
            </div>
          </mat-chip-set>

        </div>
      </div>

    </div>

  </div>

  <app-pop-up-footer (closeEvent)="close()" (saveEvent)="save()"
    [disabledButton]="!checkIfCategorySelected() || !checkIfTypeSelected()"></app-pop-up-footer>

</div>
